exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-571a681a] {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  font-size: 8px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  margin-left: 4px;\n  cursor: default;\n  background-color: #23B32F;\n}", ""]);

// exports
